import { useNavigate } from "react-router-dom";
import { FreeTrialCard } from "./subscription/FreeTrialCard";
import { PlanCard } from "./subscription/PlanCard";
import { ContactSalesCard } from "./subscription/ContactSalesCard";

const plans = [
  {
    name: "Freemium (Free Trial)",
    price: "$0",
    features: [
      "14-day access to all features",
      "Full platform capabilities",
      "Dedicated onboarding support",
      "Unlimited assessments",
      "Premium support during trial"
    ]
  },
  {
    name: "Basic",
    price: "$49",
    priceId: import.meta.env.VITE_STRIPE_BASIC_PRICE_ID,
    features: [
      "Personal cognitive assessment",
      "Basic monitoring dashboard",
      "Email support",
      "Educational resources"
    ]
  },
  {
    name: "Family",
    price: "$99",
    priceId: import.meta.env.VITE_STRIPE_FAMILY_PRICE_ID,
    features: [
      "Everything in Basic",
      "Family monitoring tools",
      "Care coordination",
      "24/7 support",
      "Priority access to trials"
    ]
  }
];

export const Subscription = () => {
  const navigate = useNavigate();

  const handleSubscribe = (planName: string) => {
    const planKey = planName === "Freemium (Free Trial)" ? "Free Trial" : planName;
    
    const selectedPlan = plans.find(p => p.name === planName);
    if (!selectedPlan) return;

    navigate(`/payment?plan=${planKey}&price=${selectedPlan.price}&priceId=${selectedPlan.priceId}`);
  };

  const handleContactSales = () => {
    navigate('/contact-sales');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-4">Choose Your Plan</h1>
      <p className="text-xl text-muted-foreground text-center mb-12">
        Select the plan that best fits your needs and start your journey to better cognitive health.
      </p>

      <div className="space-y-8 animate-fade-in">
        <FreeTrialCard onSubscribe={handleSubscribe} />

          <div className="grid md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <PlanCard
                key={plan.name}
                name={plan.name}
                price={plan.price}
                priceId={plan.priceId}
                features={plan.features}
                onSubscribe={handleSubscribe}
              />
            ))}
          </div>

        <ContactSalesCard onContact={handleContactSales} />
      </div>
    </div>
  );
};